import React, {useEffect, useState} from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  Alert,
  CircularProgress
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import Header from "../common/Header";
import {buttonStyle, inputStyle} from "../styles";
import {useNavigate} from "react-router-dom";
import {BASIC_URL} from "../enum";

const ForgotPassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const token = localStorage.getItem("jwt");
    if (token) {
      navigate("/company");
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if (!email) {
      setError(t('forgot.error.required'));
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${BASIC_URL}/api/auth/forgot-password`, {
        email
      });
      setSuccess(true);
      setEmail('');
    } catch (err) {
      console.error(err);
      setError(t('forgot.error.failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Container maxWidth='xs' sx={{ pb: 3 }}>
        <Box mt={4} mb={3}>
          <Typography variant='h4' align='center' gutterBottom>
            {t('forgot.title')}
          </Typography>
          <Typography variant='body1' align='center'>
            {t('forgot.subtitle')}
          </Typography>
        </Box>

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            margin='normal'
            label={t('forgot.email')}
            type='email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            sx={inputStyle}
          />

          <Box mt={3} position='relative'>
            <Button type='submit' variant='contained' fullWidth disabled={loading} sx={buttonStyle}>
              {t('forgot.submit')}
            </Button>
            {loading && (
              <CircularProgress
                size={24}
                sx={{ position: 'absolute', top: '50%', right: '16px', mt: '-12px' }}
              />
            )}
          </Box>
        </form>

        {success && (
          <Box mt={2}>
            <Alert severity='success'>{t('forgot.success')}</Alert>
          </Box>
        )}
        {error && (
          <Box mt={2}>
            <Alert severity='error'>{error}</Alert>
          </Box>
        )}
      </Container>
    </>
  );
};

export default ForgotPassword;
